import { forwardRef } from 'react';
import styled from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';
import type { AttributesWithoutRef } from '@pega/cosmos-react-core';
import { getTableStyles } from '@pega/cosmos-react-core/lib/components/HTML/HTML';

const StyledTable = styled.table(props => getTableStyles(props.theme));

StyledTable.defaultProps = defaultThemeProp;

export const TableBody = forwardRef<HTMLTableSectionElement, AttributesWithoutRef<'tbody'>>(
  function TableBody({ children, ...restProps }, ref) {
    return (
      <tbody {...restProps} ref={ref}>
        {children}
      </tbody>
    );
  }
);

export const Table = forwardRef<HTMLTableElement, AttributesWithoutRef<'table'>>(function Table(
  { children, ...restProps },
  ref
) {
  return (
    <StyledTable {...restProps} ref={ref}>
      {children}
    </StyledTable>
  );
});

export const TableRow = forwardRef<HTMLTableRowElement, AttributesWithoutRef<'tr'>>(
  function TableRow({ children, ...restProps }, ref) {
    return (
      <tr {...restProps} ref={ref}>
        {children}
      </tr>
    );
  }
);

export const TableHead = forwardRef<HTMLTableSectionElement, AttributesWithoutRef<'thead'>>(
  function TableHead({ children, ...restProps }, ref) {
    return (
      <thead {...restProps} ref={ref}>
        {children}
      </thead>
    );
  }
);

export const TableCell = forwardRef<HTMLTableCellElement, AttributesWithoutRef<'td'>>(
  function TableCell({ children, ...restProps }, ref) {
    return (
      <td {...restProps} ref={ref}>
        {children}
      </td>
    );
  }
);

export const TableHeaderCell = forwardRef<HTMLTableCellElement, AttributesWithoutRef<'th'>>(
  function TableHeaderCell({ children, ...restProps }, ref) {
    return (
      <th {...restProps} ref={ref}>
        {children}
      </th>
    );
  }
);
